import React from 'react';

/**
 * MetaRow renders sub-headings, degrees, job roles, or locations.
 */
export const MetaRow = ({ subtitle, leftMeta, rightMeta, style = {} }) => {
  if (!subtitle && !leftMeta && !rightMeta) return null;
  return (
    <div 
      className="block-meta-row" 
      style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'baseline', 
        fontSize: 'var(--font-size-body, 9pt)', 
        color: 'var(--color-secondary, #203C56)', 
        fontWeight: 'var(--weight-medium, 500)',
        margin: '2px 0 6px 0',
        letterSpacing: '0.02em',
        width: '100%',
        ...style 
      }}
    >
      <div>
        {subtitle && <span>{subtitle}</span>}
        {leftMeta && (
          <span style={{ fontSize: 'var(--font-size-meta, 8pt)', color: 'var(--color-text-light, #7F8C8D)', marginLeft: '6px' }}>
            {leftMeta}
          </span>
        )}
      </div>
      {rightMeta && (
        <span 
          style={{ 
            fontSize: 'var(--font-size-meta, 8pt)', 
            color: 'var(--color-text-light, #7F8C8D)', 
            fontStyle: 'italic',
            whiteSpace: 'nowrap'
          }}
        >
          {rightMeta}
        </span>
      )}
    </div>
  );
};
export default MetaRow;
